import {
  VERIFICATION_UPDATED_AT,
  VerificationUpdatedAtAction
} from "./actionTypes";

export const VerificationUpdatedAt = (): VerificationUpdatedAtAction => ({
  type: VERIFICATION_UPDATED_AT
});
